var map = {
	"./EN.svg": "adb7",
	"./arrow-back.svg": "b8a8",
	"./arrow-down-blue.svg": "24f7",
	"./arrow-down.svg": "c874",
	"./arrow-right-blue.svg": "fcb8",
	"./arrow-right-orange.svg": "092f",
	"./arrow-right-purple.svg": "5cb0",
	"./arrow-white.svg": "0e6c",
	"./arrow.svg": "21e2",
	"./banners-io/graph.svg": "9fc2",
	"./banners-io/school.svg": "4fdb",
	"./banners-io/smile.svg": "3d62",
	"./blog.svg": "9425",
	"./blue-clock.svg": "499c",
	"./chart-settings.svg": "67c1",
	"./close.svg": "8b1b",
	"./cross-grey.svg": "fe2b",
	"./cross-white.svg": "f02c",
	"./cross.svg": "2ad7",
	"./edit.svg": "daf0",
	"./globe.svg": "0de3",
	"./globe_v2.svg": "9664",
	"./grey-arrow.svg": "e33c",
	"./hamburger-menu.svg": "b602",
	"./lock-blue.svg": "b47b",
	"./log-out.svg": "3367",
	"./minus-blue.svg": "b6dc",
	"./old/lock-blue.svg": "9a1f",
	"./old/tariff_cross.svg": "c16b",
	"./old/tariff_tick.svg": "1bf7",
	"./pencil.svg": "e51f",
	"./person.svg": "d104",
	"./plus-blue.svg": "cc0d",
	"./plus.svg": "eb38",
	"./question.svg": "9872",
	"./sign-in.svg": "1319",
	"./star-fill-blue.svg": "ca5e",
	"./star-outline-blue.svg": "89bc",
	"./star.svg": "cc90",
	"./stars-demo.svg": "880e",
	"./study.svg": "975a",
	"./support-blue.svg": "b9cf",
	"./support.svg": "33f5",
	"./swap.svg": "b008",
	"./tariff_cross.svg": "7505",
	"./tariff_tick.svg": "07f6",
	"./tariffs_icon-sidebar.svg": "08bd",
	"./tariffs_icon.svg": "688c",
	"./telegram.svg": "2b29",
	"./telegram_v2.svg": "93da",
	"./tick-in-circle.svg": "306d",
	"./trash.svg": "af22",
	"./user-profile.svg": "6a31",
	"./white-clock.svg": "f13a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";